import { render, staticRenderFns } from "./Politica.vue?vue&type=template&id=0c0b5cac&"
import script from "./Politica.vue?vue&type=script&lang=js&"
export * from "./Politica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports